import axios from '../utils/axios/axiosApi'

const addAuditLogin = (request) => {
    return new Promise((resolve, reject) => {
        axios.post('Audit/AddLoginAuditPerson', request)
             .then((response) => {
                resolve(response.data);
             })
             .catch((error) => {
                reject(error);
             });
    });
}

export {
    addAuditLogin
}